import Config from "@/config";
import {obtainClientId} from "@/utils/auth";

/**
 * Вызывает HTTP-команду backend (/api/task/<name>) и возвращает result.
 * Состояние store не трогает - обновление данных выполняет вызывающий код.
 * @param name - имя команды
 * @param params - тело запроса
 */
async function taskCommand(name, params) {
	const res = await fetch(Config.HOST + "/api/task/" + name, {
		method: "POST",
		headers: {
			Authorization: "Bearer " + obtainClientId(),
			"Content-Type": "application/json",
		},
		body: JSON.stringify(params),
	});

	let body = null;
	try {
		body = await res.json();
	} catch (e) {
	}
	if (!res.ok || body?.error) throw new Error(body?.error?.message || ("task/" + name + ": " + res.status));
	return body?.result;
}

/**
 * Читает одну задачу HTTP-командой backend (GET /api/task/get). Состояние store не трогает.
 * @param taskId - id задачи
 * @returns {Promise<{task: object, contextTasks: Array<{contextId: string, taskId: string, index: number}>}>}
 *          contextTasks - в каких контекстах лежит задача и под каким index
 */
export async function fetchTask(taskId) {
	const query = new URLSearchParams({taskId, includeContextTasks: "true"});
	const res = await fetch(Config.HOST + "/api/task/get?" + query, {
		headers: {Authorization: "Bearer " + obtainClientId()},
	});

	let body = null;
	try {
		body = await res.json();
	} catch (e) {
	}
	if (!res.ok || body?.error) throw new Error(body?.error?.message || ("task/get: " + res.status));
	return body?.result;
}

/**
 * Меняет местами цель процесса и его последний назначаемый шаг: шаг становится новой целью
 * (процессом) на месте старой, а старая цель - обычным шагом в позиции index.
 * @param processId - id процесса (его цель перетащили)
 * @param fromContextId - id родителя процесса
 * @param index - индекс (context_task.index) старой цели среди шагов
 * @returns {Promise<{processId: string, newProcessId: string, fromContextId: string}>}
 */
export function swapProcessGoal(processId, fromContextId, index, goalTaskId) {
	return taskCommand("swapProcessGoal", {processId, fromContextId, index, goalTaskId});
}
